export const hasRebetCountdown = (items: { event?: { blockedUntil?: number } }[] | undefined, now = Date.now()) => {
  const nowSeconds = Math.floor(now / 1000);
  return (items ?? []).some((item) => (item.event?.blockedUntil ?? 0) > nowSeconds);
};
